import {
  Breadcrumbs,
  NextTabs,
  NextTabsContent,
  NextTabsList,
  NextTabsTrigger,
  Page,
  PageHeader,
} from '@cint/wonderment';
import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { ROUTES } from '@/constants';
import { useReportContext } from '@/context/ReportContext';

import { ReportDateFilters } from './ReportDateFilters';
import { ReportHeader } from './ReportHeader';

interface PanelInsightsReportLayoutProps {
  children?: React.ReactNode;
}

interface PanelInsightsReportLayoutParams {
  reportName:
    | 'financial'
    | 'survey'
    | 'retention'
    | 'demographics'
    | 'overview';
}

const tabsList = [
  { value: 'overview', label: 'Overview' },
  { value: 'retention', label: 'Retention' },
  { value: 'demographics', label: 'Demographics' },
  { value: 'survey', label: 'Survey' },
  { value: 'financial', label: 'Financials' },
];

export const PanelInsightsReportLayout = ({
  children,
}: PanelInsightsReportLayoutProps) => {
  const { filters, setFilters } = useReportContext();
  const navigate = useNavigate();
  const [panelCreatedDate, setPanelCreatedDate] = useState<Date | null>(null);
  const { reportName } = useParams() as {
    reportName?: PanelInsightsReportLayoutParams['reportName'];
  };
  const location = useLocation();

  const handleTabChange = (value) => {
    const queryString = location.search;
    navigate(`${ROUTES.panelInsights}/${value}${queryString}`);
  };

  const handlePanelCreatedDateChange = (date: Date | null) => {
    setPanelCreatedDate(date);
  };
  return (
    <>
      <PageHeader
        breadcrumbs={
          <Breadcrumbs
            iconName="ChartBar"
            segments={[{ title: 'Panel insights' }]}
          />
        }
        className="px-8"
      />

      <Page>
        <ReportHeader
          title="Panel Insights"
          reportName={reportName}
          onPanelCreatedDateChange={handlePanelCreatedDateChange}
        />
        <div className="w-full px-4">
          <NextTabs onValueChange={handleTabChange} value={reportName}>
            <div className="flex justify-between mb-10 items-center">
              <NextTabsList className="mb-page-content">
                {tabsList.map(({ label, value }) => (
                  <NextTabsTrigger value={value} key={value}>
                    {label}
                  </NextTabsTrigger>
                ))}
              </NextTabsList>
              <ReportDateFilters
                filters={filters}
                onFiltersChange={setFilters}
                minDate={panelCreatedDate}
                hasMinDate
              />
            </div>
            <NextTabsContent value={reportName}>{children}</NextTabsContent>
          </NextTabs>
        </div>
      </Page>
    </>
  );
};
